import * as z from 'zod'

import type { ContentsNeoStepConfigParams } from '@flows/configs/contents/types'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { FAILURE_STEP_NAME } from '@flows/insurance/constants'

const contents_insurance_cancelled = (params: ContentsNeoStepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getHelperPath('insurance_cancelled')]: z.boolean(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.insurance_cancelled.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getHelperPath('insurance_cancelled'),
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.inputs.yes',
            },
            value: true,
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.inputs.no',
            },
            value: false,
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getHelperPath('insurance_cancelled'),
      valueToStepName: {
        true: FAILURE_STEP_NAME,
        false: 'contents_deductibles',
      },
    },
  }) as const satisfies AnyStepConfiguration

export default contents_insurance_cancelled
